/* eslint-disable @typescript-eslint/no-explicit-any */
export function normalizeCMSData(data: any): any {
  const isObject = (data: any) =>
    Object.prototype.toString.call(data) === '[object Object]'

  if (Array.isArray(data)) {
    return data.map((item) => normalizeCMSData(item))
  }

  if (isObject(data)) {
    if (Array.isArray(data.data)) {
      data = [...data.data]
    } else if (data.data === null) {
      data = null
    }

    if (data?.provider === 'cloudinary') {
      const path = data?.provider_metadata?.public_id
      delete data.provider_metadata
      data = { ...data, path }
    }
    if (data?.__component) {
      const name = data.__component
      delete data.__component
      data = { ...data, name }
    }
    for (const key in data) {
      data[key] = normalizeCMSData(data[key])
    }
    return data
  }
  return data
}
